import React from 'react';
import { Row, Col, Label } from "reactstrap";

export default class ContainersDetalhesLacre extends React.Component {

    constructor(props) {
        super(props);
    }
    
    render() {
        return (
            <div className="containers-detalhes-sem-borda">
                <h2>Lacres</h2> 
                <Row>
                    {this.props.dados.Lacre1 && <Col xs={"auto"} className="containers-detalhes-col">
                        <div className="card">
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{ this.props.dados.Lacre1 ? this.props.dados.Lacre1 : "---" }</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-disabled">{ this.props.dados.DtInclLacre1 ? this.props.dados.DtInclLacre1 : "---" }</Label>
                                </Col>
                            </Row>
                        </div>
                    </Col>}
                    {this.props.dados.Lacre2 && <Col xs={"auto"} className="containers-detalhes-col">
                        <div className="card">
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{ this.props.dados.Lacre2 ? this.props.dados.Lacre2 : "---" }</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-disabled">{ this.props.dados.DtInclLacre2 ? this.props.dados.DtInclLacre2 : "---" }</Label>
                                </Col>
                            </Row>
                        </div>
                    </Col>}
                    {this.props.dados.Lacre3 && <Col xs={"auto"} className="containers-detalhes-col">
                        <div className="card">
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{ this.props.dados.Lacre3 ? this.props.dados.Lacre3 : "---" }</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-disabled">{ this.props.dados.DtInclLacre3 ? this.props.dados.DtInclLacre3 : "---" }</Label>
                                </Col>
                            </Row>
                        </div>
                    </Col>}
                    {this.props.dados.Lacre4 && <Col xs={"auto"} className="containers-detalhes-col">
                        <div className="card">
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{ this.props.dados.Lacre4 ? this.props.dados.Lacre4 : "---" }</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-disabled">{ this.props.dados.DtInclLacre4 ? this.props.dados.DtInclLacre4 : "---" }</Label>
                                </Col>
                            </Row>
                        </div>
                    </Col>}
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/containers/components/ContainersDetalhesLacre.js